/** Categorized telecalling dispositions for Pre-Lead "Update Status". */

export const PRELEAD_STATUS_CATEGORY = {
  CONNECTED_QUALIFIED: 'connected_qualified',
  CONNECTED_UNQUALIFIED: 'connected_unqualified',
  NOT_CONNECTED: 'not_connected'
};

export const PRELEAD_STATUS_CATEGORIES = [
  {
    key: PRELEAD_STATUS_CATEGORY.CONNECTED_QUALIFIED,
    label: 'Connected & Qualified',
    emoji: '✅',
    options: [
      'Looking to Buy (0–3 Months)',
      'Looking to Buy (3–12 Months)',
      'Wants Project Details',
      'Wants Site Visit',
      'Wants Callback',
      'Budget Matches',
      'Comparing Projects',
      'Follow-up Required',
      'Others'
    ]
  },
  {
    key: PRELEAD_STATUS_CATEGORY.CONNECTED_UNQUALIFIED,
    label: 'Connected & Unqualified',
    emoji: '❌',
    options: [
      'Not Interested',
      'Budget Mismatch',
      'Wrong Location',
      'Wrong Property Requirement',
      'Looking for Rental',
      'Already Purchased',
      'Broker / Channel Partner',
      'Fake / Duplicate Enquiry',
      'Others'
    ]
  },
  {
    key: PRELEAD_STATUS_CATEGORY.NOT_CONNECTED,
    label: 'Not Connected',
    emoji: '📞',
    options: [
      'No Answer',
      'Busy',
      'Call Rejected',
      'Switched Off',
      'Out of Coverage',
      'Wrong / Invalid Number',
      'Call Disconnected',
      'Language Barrier',
      'Others'
    ]
  }
];

export function getPreleadStatusCategory(categoryKey) {
  return PRELEAD_STATUS_CATEGORIES.find((c) => c.key === categoryKey) ?? null;
}

/** Format status + remarks for prelead notes history. */
export function formatPreleadStatusNote(categoryKey, statusLabel, notes) {
  const category = getPreleadStatusCategory(categoryKey);
  const categoryLabel = category
    ? `${category.emoji} ${category.label}`
    : String(categoryKey ?? '').trim();
  const status = String(statusLabel ?? '').trim();
  const remarks = String(notes ?? '').trim();

  const lines = [`[${categoryLabel}]`];
  if (status) lines.push(`Reason: ${status}`);
  if (remarks) lines.push(`Notes: ${remarks}`);
  return lines.join('\n');
}
